import { Head } from '@inertiajs/react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import type { AdminProjectsIndex } from '@/types';
import { ProjectFilters } from './components/ProjectFilters';
import { ProjectTable } from './components/ProjectTable';

export default function Index({
  event,
  eventSlug,
  projects,
  pagination,
  filters,
  title,
}: AdminProjectsIndex) {
  return (
    <>
      <Head title={title} />
      <div className="container mx-auto space-y-6 py-8">
        <div>
          <h1 className="font-bold text-3xl tracking-tight">Projects</h1>
          <p className="text-muted-foreground">
            Review and manage project submissions for {event.name}
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Filters</CardTitle>
          </CardHeader>
          <CardContent>
            <ProjectFilters eventSlug={eventSlug} initialParams={filters} />
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-0">
            <ProjectTable
              eventSlug={eventSlug}
              projects={projects}
              pagination={pagination}
            />
          </CardContent>
        </Card>
      </div>
    </>
  );
}
